<template>
  <span>
    <a href="#/" @click="showModalReviews()"><i 
      v-for="n in Math.floor(stars)"  
      :key="n" 
      class="fas fa-star mr-1 stars" 
      :title="stars + ' ' + (stars === 1 ? 'star' : 'stars')">
    </i></a><a href="#/" class="blue2 ml-1" @click="showModalReviews()">{{total}} {{ total === 1 ? 'review' : 'reviews' }}</a>
  </span>
</template>

<script>
export default {
  props: ['stars','total'],

  methods: {
    showModalReviews() {
      this.$root.$emit('bv::show::modal', 'bv-modal-reviews');
    }
  }

};
</script>
